import BaseComponent from "../../../../lib/components/BaseComponent";
import PropTypes from "prop-types";
import GF from "../../../../lib/utils/GF";
import Button from "../buttons/Button";
import {EditNote} from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";

class ButtonTabVariables extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      isChanged: GF.getValue(this.props.isChanged, false)
    }
  }

  onClick(e) {
    if (this.props.onClick !== undefined) {
      this.props.onClick(e, this.props.id);
    }
  }

  setIsChanged(isChanged) {
    this.state.isChanged = isChanged;
    this.setState(this.state);
  }

  render() {
    let icon = this.state.isChanged ? <Tooltip title='Änderungen wurden vorgenommen'><EditNote/></Tooltip> : '';
    let color = this.props.isActive ? 'secondary' : 'primary';
    return <Button
      sx={{justifyContent: 'space-between'}}
      color={color}
      endIcon={icon}
      onClick={(e) => this.onClick(e)}>
      <span className='text-left'>{this.props.children}</span>
    </Button>;
  }
}

ButtonTabVariables.propTypes = {
  className: PropTypes.string, onClick: PropTypes.func, id: PropTypes.string, isChanged: PropTypes.bool,
}
export default ButtonTabVariables;
